module.exports = __webpack_public_path__ + "img/map.210ea144.jpg";